import PlusIcon from '@assets/icons/cross.svg?react'
import SettingsIcon from '@assets/icons/settings.svg?react'
import cn from 'classnames'
import { paths } from 'mmfintech-backend-api'
import { GlobalContext, tr } from 'mmfintech-commons'
import { MMButton } from 'mmfintech-portal-commons'
import { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import styles from './NotificationsPanel.module.scss'

// cross.svg is a plus drawn with currentColor; rotated it becomes a theme-aware close icon
const CloseIcon = () => <PlusIcon className={cn(styles['notifications-close-icon'], 'notifications-close-icon')} />

export const NotificationsPanelHeader = () => {
  const { sidebarRightHide } = useContext(GlobalContext)
  const history = useHistory()

  const handleOpenSettings = () => {
    sidebarRightHide()
    history.push(`${paths.profile()}/notifications`)
  }

  return (
    <div className={cn(styles['notifications-header'], 'notifications-header')}>
      <h2 className={cn(styles['notifications-title'], 'notifications-title')}>
        {tr('FRONTEND.NOTIFICATIONS_PANEL.TITLE', 'Notification center')}
      </h2>
      <div className={cn(styles['notifications-header-actions'], 'notifications-header-actions')}>
        <MMButton
          type='button'
          size='normal'
          variant='tertiary'
          collapsed
          collapsedIcon={SettingsIcon}
          title={tr('FRONTEND.NOTIFICATIONS_PANEL.SETTINGS', 'Notification settings')}
          onClick={handleOpenSettings}
          data-test='notifications-settings'
        />
        <MMButton
          type='button'
          size='normal'
          variant='tertiary'
          collapsed
          collapsedIcon={CloseIcon}
          title={tr('FRONTEND.NOTIFICATIONS_PANEL.CLOSE', 'Close')}
          onClick={sidebarRightHide}
          data-test='notifications-close'
        />
      </div>
    </div>
  )
}
